import AvatarsContainer from "../../components/uiKits/avatars"

const Avatars = () => {
  return <AvatarsContainer/>;
};

export default Avatars;
